import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from './../../../../environments/environment';

@Injectable()
export class AuthenticationService {

  private baseUrlService: string
  private baseUrlCodigo: string
  private baseUrlSenha: string
  private baseUrlGuid: string

  constructor(private http: HttpClient) {
    this.baseUrlService = environment.URL_API + '/admin/login'
    this.baseUrlSenha = environment.URL_API + '/admin/redefinirSenha'
    this.baseUrlCodigo = environment.URL_API + '/admin'
    this.baseUrlGuid = environment.URL_API + '/admin/adicionarGUID?username='
  }

 

  login(username: string, password: string, guid: string) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const httpOptions = { headers: headers };
    const body = `&username=${username}&password=${password}&confianca=${guid}`;
    
    return this.http.post(this.baseUrlService, body, httpOptions);
  }

  validarCodigo(username: string, password: string, codigo: number, checkbox: boolean) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const httpOptions = { headers: headers };
    const body = `&username=${username}&password=${password}&codigo=${codigo}&confDispositivo=${checkbox}`;

    return this.http.post(this.baseUrlCodigo, body, httpOptions).toPromise();
  }

  redefinirSenha(username: string) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const httpOptions = { headers: headers };
    const body = `&username=${username}`;

    return this.http.post(this.baseUrlSenha, body, httpOptions).toPromise();
  }

  pegarGuid(path: string) {
    const headers = new HttpHeaders({ "Content-Type": "application/json" });
    const httpOptions = { headers: headers };
    return this.http.get<any>(`${environment.URL_API}${path}`, httpOptions);
  }

  getImagem(path: string) {
    return this.http.get<any>(`${environment.URL_API}${path}`);
  }

  
}
